<ng-container *ngIf="client">
  <div class="avatar with-icon" [class.small]="size === 'small'" [class.x-small]="size === 'x-small'" [style.background-color]="backgroundColor">
    <div class="initials">
      <ng-container *ngIf="client.firstName && client.firstName[0]">{{ client.firstName[0] }}</ng-container>
      <ng-container *ngIf="client.lastName && client.lastName[0]">{{ client.lastName[0] }}</ng-container>
    </div>
  </div>
</ng-container>
